import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from './Button';

const CookieConsentContainer = styled.div<{ isVisible: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--white);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 9999;
  transform: translateY(${props => props.isVisible ? '0' : '100%'});
  transition: transform 0.3s ease-in-out;
`;

const CookieConsentContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const CookieText = styled.p`
  margin: 0;
  flex: 1;
  font-size: 0.9rem;
  color: var(--gray-dark);
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  
  @media (max-width: 576px) {
    width: 100%;
    flex-direction: column;
  }
`;

const CookieLink = styled(Link)`
  color: var(--blue);
  text-decoration: underline;
`;

const COOKIE_CONSENT_KEY = 'cookieConsent';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      // Pequeño retraso para no mostrar inmediatamente al cargar la página
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };
  
  const declineCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsVisible(false);
    
    // Aquí podríamos deshabilitar los scripts de análisis, etc.
    // Por ejemplo, para Google Analytics:
    if (window.hasOwnProperty('ga')) {
      // @ts-ignore
      window['ga-disable-UA-XXXXX-Y'] = true;
    }
  };
  
  if (!isVisible) {
    return null;
  }
  
  return (
    <CookieConsentContainer isVisible={isVisible}>
      <CookieConsentContent>
        <CookieText>
          Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada 
          con sus preferencias mediante el análisis de sus hábitos de navegación. Si continúa navegando, consideramos 
          que acepta su uso. Puede cambiar la configuración u obtener más información en nuestra{' '}
          <CookieLink to="/politica-cookies">Política de Cookies</CookieLink>.
        </CookieText>
        <ButtonGroup>
          <Button 
            onClick={declineCookies} 
            variant="outline" 
            size="small"
          >
            Rechazar
          </Button>
          <Button 
            onClick={acceptCookies} 
            size="small"
          >
            Aceptar
          </Button>
        </ButtonGroup>
      </CookieConsentContent>
    </CookieConsentContainer>
  );
};

export default CookieConsent; 